import { useTheme as useGenieTheme } from '@genie-fintech/ui/hooks'
import { lightTheme, darkTheme } from '$styles/themes/mode.css'

export const useAppTheme: typeof useGenieTheme = () => {
  const { mode, ...rest } = useGenieTheme()

  const className = mode.isDarkMode ? darkTheme : lightTheme

  return {
    ...rest,
    className,
    mode
  }
}
